export const BASE_URL       = 'http://www.sheikhaalarifi.com/api';
export const FACEBOOK_ID    = '1053718488351648'
export const GOOGLE_ID      = '869373708241-108ij95m8q0poo7ont8h9sghaf6f1a48.apps.googleusercontent.com'
export const RECAPTCHA      = '6LeEz_0hAAAAALYs3I-jTE3dvdC6JNAWnnD1jUUK'
